export const LOADING_AXIS = "LOADING_AXIS"
export const FETCH_ALL_AXIS = "FETCH_ALL_AXIS"
export const FETCH_ALL_AXIS_FAIL = "FETCH_ALL_AXIS_FAIL"



export const LOADING_ONE_AXIS = "LOADING_ONE_AXIS"

export const FETCH_ONE_AXIS = "FETCH_ONE_AXIS"
export const FETCH_ONE_AXIS_FAIL = "FETCH_ONE_AXIS_FAIL"

export const PATCH_ONE_AXIS = "PATCH_ONE_AXIS"
export const PATCH_ONE_AXIS_FAIL = "PATCH_ONE_AXIS"

export const POST_AXIS = "POST_AXIS"
export const POST_AXIS_FAIL = "POST_AXIS_FAIL"

export const DELETE_AXIS = "DELETE_AXIS"
export const DELETE_AXIS_FAIL = "DELETE_AXIS_FAIL"

export const CLEAR_ONE_AXIS = "CLEAR_ONE_AXIS"
export const CLEAR_AXIS = "CLEAR_AXIS"